import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PoAutoCreatePageRoutingModule } from './po-auto-create-routing.module';

import { PoAutoCreatePage } from './po-auto-create.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PoAutoCreatePageRoutingModule,
    ReactiveFormsModule,
    IonicSelectableModule
  ],
  declarations: [PoAutoCreatePage]
})
export class PoAutoCreatePageModule {}
